import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import {
  ProfileStats,
  ProfileStatsContainer,
  ProfileAvatar,
  ProfileBoxContainer,
} from './styled';
import ProfileStatsAttribute from './ProfileHeader/ProfileStatsAttribute';

const { Flex, Text } = Common;

const DeletedUser = () => (
  <>
    <ProfileBoxContainer>
      <Flex align="flex-start">
        <ProfileAvatar>
          <Image src="/images/avatar.png" alt="User Not Found Avatar" />
        </ProfileAvatar>
        <Flex width="100%" direction="column" padding="0 0 0 20px">
          <Flex width="100%" wrap="wrap" justify="space-between">
            <Flex direction="column">
              <Flex>
                <Text as="h1" size="20px" family="bold" margin="0 0 2px 0">
                  Stockbit User
                </Text>
              </Flex>
            </Flex>
          </Flex>

          <ProfileStatsContainer>
            <ProfileStats role="button">
              <ProfileStatsAttribute value={0} label="Posts" />
            </ProfileStats>
            <ProfileStats role="button">
              <ProfileStatsAttribute value={0} label="Followers" />
            </ProfileStats>
            <ProfileStats role="button">
              <ProfileStatsAttribute value={0} label="Following" />
            </ProfileStats>
          </ProfileStatsContainer>
        </Flex>
      </Flex>
    </ProfileBoxContainer>
    <ProfileBoxContainer>
      <Flex
        align="center"
        justify="center"
        direction="column"
        style={{ height: 660 }}
      >
        <img
          src="/images/user-not-found.svg"
          alt="User Not Found Illustration"
          style={{ width: 160, height: 120 }}
        />
        <Text
          as="h2"
          size="18px"
          family="bold"
          style={{ margin: '25px 0 12px 0' }}
        >
          User Not Found
        </Text>
        <Text as="span" size="15px" color="#b5b5b5">
          This user has deleted their account
        </Text>
      </Flex>
    </ProfileBoxContainer>
  </>
);

export default DeletedUser;
